import { v4 as uuid } from 'uuid';
import { create } from 'zustand';

import type { Notification } from '@ifs-gcp/components';

interface NotificationState {
  notifications: Notification[];
  notify: (notification: Omit<Notification, 'onClose' | 'id'>) => void;
  removeNotification: (id: string) => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  notify: (notification) =>
    set((state) => ({
      notifications: [...state.notifications, { ...notification, id: uuid() }],
    })),
  removeNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((notification) => notification.id !== id),
    })),
}));
